@if (showBackButton) {
  <div class="inner-navigation">
    <div class="back" (click)="navigateBack()">
      <p class="text-button-small">{{ 'account.back-button-text' | translate }}</p>
    </div>
  </div>
}

<div class="page-name">
  <h3>{{ 'forgot-password.title' | translate }}</h3>
</div>

<div class="block">
  <div class="row">
    <div class="title">
      <p class="subtitle-14">{{ 'forgot-password.code-title' | translate }}</p>
    </div>

    <div class="input">
      <input
        class="input"
        type="text"
        placeholder="{{ 'forgot-password.code-placeholder' | translate }}"
        [(ngModel)]="code"
        />
      </div>
    </div>

    <div class="row">
      <div class="title">
        <p class="subtitle-14">{{ 'forgot-password.new-password-title' | translate }}</p>
      </div>

      <div class="input">
        <input
          class="input"
          [type]="showNewPassword ? 'text' : 'password'"
          placeholder="{{ 'forgot-password.new-password-placeholder' | translate }}"
          [(ngModel)]="newPassword"
          />
          <mat-icon svgIcon="eye" [class.active]="showNewPassword"
          (click)="$event.stopPropagation(); showNewPassword = !showNewPassword"></mat-icon>

        </div>
      </div>

      <div class="row">
        <div class="title">
          <p class="subtitle-14">{{ 'forgot-password.confirm-password-title' | translate }}</p>
        </div>

        <div class="input">
          <input
            class="input"
            [type]="showConfirmPassword ? 'text' : 'password'"
            placeholder="{{ 'forgot-password.confirm-password-placeholder' | translate }}"
            [(ngModel)]="confirmPassword"
            />
            <mat-icon svgIcon="eye" [class.active]="showConfirmPassword"
            (click)="$event.stopPropagation(); showConfirmPassword = !showConfirmPassword"></mat-icon>
          </div>
        </div>

        <div class="row">
          @for (error of errors; track error) {
            <div class="error">
              <p class="body-12 error">{{ error | translate }}</p>
            </div>
          }
        </div>

        <ul class="row password-requirements">
          <li class="body-12 password-requirement-item">{{'forgot-password.password-requirements.length' | translate}}</li>
          <li class="body-12 password-requirement-item">{{'forgot-password.password-requirements.number' | translate}}</li>
          <li class="body-12 password-requirement-item">{{'forgot-password.password-requirements.special' | translate}}</li>
          <li class="body-12 password-requirement-item">{{'forgot-password.password-requirements.uppercase' | translate}}</li>
          <li class="body-12 password-requirement-item">{{'forgot-password.password-requirements.lowercase' | translate}}</li>
        </ul>
      </div>

      <div class="flex-placeholder"></div>

      <div class="actions">
        <button class="button secondary" (click)="navigateBack()">
          {{ 'forgot-password.cancel-button' | translate }}
        </button>

        <button class="button primary" (click)="resetPassword()">
          {{ 'forgot-password.reset-button' | translate }}
        </button>
      </div>
